import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { useComposer } from "@zapier/agent-system";
import { composerServiceAtom } from "@zapier/canvas-state";

/**
 * This component initializes the composerServiceAtom with the composer context
 * It should be rendered inside the ComposerProvider but outside the Composer component
 */
export function ComposerInitializer() {
  const { sendMessage, resetChat, setMessages, handleSubmit } = useComposer();
  const setComposerService = useSetAtom(composerServiceAtom);

  useEffect(() => {
    // Initialize the composer service atom with the composer context methods
    setComposerService({
      sendMessage,
      resetChat,
      setMessages,
      handleSubmit,
    });

    // Clean up the service when component unmounts
    return () => {
      setComposerService(null);
    };
  }, [sendMessage, resetChat, setMessages, setComposerService, handleSubmit]);

  return null;
}

export default ComposerInitializer;
